module.exports = __webpack_public_path__ + "img/ic_raised.9f5a3c19.svg";